<template class="paddingClass">
  <div id="timeChoose">
    <a-row class="rowClass">
      <a-col class="colClass">
        <a-form
          layout="inline"
          style="margin-top: 0"
          :form="form"
          @submit="getData($event)"
        >
          <a-form-item>
            <a-range-picker
              v-decorator="['timepicker']"
              format="YYYY-MM-DD"
              style="width: 200px"
            />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" html-type="submit" icon="search"
              >搜索</a-button
            >
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <div id="mygoChart" style="background-color: #ffffff"></div>
  </div>
</template>
<script>
import {
  myIcons,
  _nodeDataArray,
  _linkDataArray,
} from "../../utils/waterFlow.js";
import go from "gojs";
import moment from "moment"; //导入文件
import { color } from "echarts/core";
// import goDebug from "godebugjs"
const MAKE = go.GraphObject.make;
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      water: [],
      Icons: myIcons,
      myDiagram: null,
      opacity: 1,
      down: true,
      nodeDataArray: _nodeDataArray,
      linkDataArray: _linkDataArray,
      //枚举颜色
      Colors: {
        red: "#be4b15",
        green: "#52ce60",
        blue: "#6ea5f8",
        lightred: "#fd8852",
        lightblue: "#afd4fe",
        lightgreen: "#b9e986",
        pink: "#faadc1",
        purple: "#d689ff",
        orange: "#f08c00",
        black: "black",
        brown: "#CD853F",
      },
    };
  },
  created() {},
  mounted() {
    var mySelf = this;
    //构建gojs对象
    this.myDiagram = mySelf.myDiagram;
    this.myDiagram = MAKE(go.Diagram, "mygoChart", {
      initialContentAlignment: go.Spot.Center, //居中显示
      "undoManager.isEnabled": true, //支持 Ctrl-Z 和 Ctrl-Y 操作
      "toolManager.hoverDelay": 100, //tooltip提示显示延时
      "toolManager.toolTipDuration": 10000, //tooltip持续显示时间
      scale: 1, //流程图放大比例
      //isReadOnly:true,//只读
      "grid.visible": false, //显示网格
      allowMove: true, //允许拖动
      // allowDragOut:true,
      allowDelete: false,
      allowCopy: false,
      allowClipboard: false,
      "toolManager.mouseWheelBehavior": go.ToolManager.WheelZoom, //有鼠标滚轮事件放大和缩小，而不是向上和向下滚动
      // layout: MAKE(go.TreeLayout, {
      //   angle: 0,
      //   layerSpacing: 35,
      // }),
    });

    //增加事件
    this.myDiagram.addDiagramListener("ObjectSingleClicked", function (e) {
      console.log(e.subject.part);
    });
    this.myDiagram.addDiagramListener("BackgroundSingleClicked", function (e) {
      console.log("Double-clicked at" + e.diagram.lastInput.documentPoint);
    });
    this.myDiagram.addDiagramListener("ClipboardPasted", function (e) {
      console.log("Pasted" + e.diagram.selection.count + "parts");
    });

    // 定义节点模板
    this.myDiagram.nodeTemplate = MAKE(
      go.Node,
      "Spot",
      {
        locationObjectName: "PORT",
        locationSpot: go.Spot.Top,
        linkConnected: this.updatePortHeight,
        linkDisconnected: this.updatePortHeight,
        toolTip: MAKE(
          "ToolTip",
          MAKE(
            go.TextBlock,
            { margin: 4, width: 140 },
            new go.Binding("text", "", function (data) {
              return data.text + ":\n\n" + data.description;
            })
          )
        ),
      },
      new go.Binding("location", "pos", go.Point.parse).makeTwoWay(
        go.Point.stringify
      ),
      MAKE(
        go.Panel,
        "Vertical",
        MAKE(
          go.Shape,
          {
            width: 40,
            height: 0,
            stroke: null,
            strokeWidth: 0,
            fill: "gray",
          },
          new go.Binding("height", "icon", function () {
            return 40;
          }),
          new go.Binding("fill", "color", this.colorFunc),
          new go.Binding("geometry", "icon", this.geoFunc)
        ),
        MAKE(
          go.Shape,
          {
            name: "PORT",
            width: 40,
            height: 24,
            margin: new go.Margin(-1, 0, 0, 0),
            stroke: null,
            strokeWidth: 0,
            fill: "gray",
            portId: "",
            fromLinkable: true,
            toLinkable: true,
          },
          new go.Binding("fill", "color", this.colorFunc)
        ),
        MAKE(
          go.TextBlock,
          {
            font: "Bold 13px Lato, sans-serif",
            textAlign: "center",
            margin: 3,
            // stroke: "back",//设置线上文字颜色
            maxSize: new go.Size(120, NaN),
            alignment: go.Spot.Top,
            alignmentFocus: go.Spot.Bottom,
            editable: true,
          },
          new go.Binding("text").makeTwoWay()
        )
      )
    );

    //定义连线模板
    this.myDiagram.linkTemplate = MAKE(
      go.Link,
      {
        layerName: "Background",
        routing: go.Link.Orthogonal,
        corner: 10,
        reshapable: true,
        resegmentable: true,
        fromSpot: go.Spot.RightSide,
        toSpot: go.Spot.LeftSide,
      },
      // make sure links come in from the proper direction and go out appropriately
      new go.Binding("fromSpot", "fromSpot", go.Spot.parse),
      new go.Binding("toSpot", "toSpot", go.Spot.parse),
      new go.Binding("points").makeTwoWay(),
      // mark each Shape to get the link geometry with isPanelMain: true
      MAKE(
        go.Shape,
        { isPanelMain: true, stroke: "gray", strokeWidth: 8 }, //线条粗细
        // get the default stroke color from the fromNode
        new go.Binding("stroke", "fromNode", function (n) {
          return go.Brush.lighten(
            (n && this.Colors[n.data.color]) || "#4ea5f8"
          );
        }).ofObject(),
        // but use the link's data.color if it is set
        new go.Binding("stroke", "color", this.colorFunc)
      ),
      MAKE(go.Shape, {
        isPanelMain: true,
        stroke: "white",
        strokeWidth: 3, //流动块的宽度
        name: "PIPE",
        strokeDashArray: [20, 40],
      }),
      MAKE(
        go.TextBlock, // show the second path object name, if any
        {
          segmentOffset: new go.Point(-5, 15), //数值位置
          font: "Bold 12px Lato, sans-serif",
        }, //设置文字在线之上
        new go.Binding("text", "text")
      )
    );

    //循环流动
    loop();
    var opacity = 1;
    var down = true;
    function loop() {
      var diagram = mySelf.myDiagram;
      setTimeout(function () {
        var oldskips = diagram.skipsUndoManager;
        diagram.skipsUndoManager = true;
        diagram.links.each(function (link) {
          var shape = link.findObject("PIPE");
          var off = shape.strokeDashOffset - 3;
          // animate (move) the stroke dash
          shape.strokeDashOffset = off <= 0 ? 60 : off;
          // animte (strobe) the opacity:
          if (down) opacity = opacity - 0.01;
          else opacity = opacity + 0.003;
          if (opacity <= 0) {
            down = !down;
            opacity = 0;
          }
          if (opacity > 1) {
            down = !down;
            opacity = 1;
          }
          shape.opacity = opacity;
        });
        diagram.skipsUndoManager = oldskips;
        loop();
      }, 120); //流速
    }

    //获取数据
    if (this.$store.getters.timeList) {
      this.form.setFieldsValue({
        timepicker: [
          moment(this.$store.getters.timeList, "YYYY-MM-DD"),
          moment(this.$store.getters.timeList, "YYYY-MM-DD"),
        ],
      });
      this.getData();
    }
  },
  methods: {
    //筛选颜色
    colorFunc(colorname) {
      var c = this.Colors[colorname];
      if (c) return c;
      return "gray";
    },
    //字符串转地理对象
    geoFunc(geoname) {
      var geo = this.Icons[geoname];
      if (typeof geo === "string") {
        geo = this.Icons[geoname] = go.Geometry.parse(geo, true);
      }
      return geo;
    },
    //更新连接点
    updatePortHeight(node, link, port) {
      var sideinputs = 0;
      var sideoutputs = 0;
      node.findLinksConnected().each(function (l) {
        if (l.toNode === node && l.toSpot === go.Spot.LeftSide) sideinputs++;
        if (l.fromNode === node && l.fromSpot === go.Spot.RightSide)
          sideoutputs++;
      });
      var tot = Math.max(sideinputs, sideoutputs);
      tot = Math.max(1, Math.min(tot, 2));
      port.height = tot * (10 + 2) + 2; // where 10 is the link path's strokeWidth
    },
    //获取各用水单元数据
    getData(e) {
      // e.preventDefault(); //阻止默认行为，在这里防止刷新闪屏
      this.form.validateFields((error, form) => {
        if (e) {
          e.preventDefault(); //取消默认动作
        }
        if (form.timepicker != undefined && form.timepicker.length != 0) {
          var startTime = moment(form.timepicker[0]).format("YYYY-MM-DD");
          var endTime = moment(form.timepicker[1]).format("YYYY-MM-DD");
          this.$http
            .get("/device/realData", {
              params: { beginTime: startTime, endTime: endTime },
            })
            .then((res) => {
              res.data.forEach((element) => {
                if (element.deviceNo == 29) {
                  this.linkDataArray[0].text = element.waterAmount.toString();
                }
                if (element.deviceNo == 30) {
                  this.linkDataArray[5].text = element.waterAmount.toString();
                }
              });
              for (var i = 0; i < res.data.length; i++) {
                //地下水
                if (res.data[i].meterNumber == "2") {
                  var a1 = res.data[i].waterAmount;
                  this.linkDataArray[0].text =
                    res.data[i].waterAmount.toString();
                } else if (res.data[i].meterNumber == "3") {
                  var a2 = res.data[i].waterAmount;
                  this.linkDataArray[0].text =
                    res.data[i].waterAmount.toString();
                }
                //地面生活水总表
                else if (res.data[i].meterNumber == "4") {
                  this.linkDataArray[1].text =
                    res.data[i].waterAmount.toString();
                }
                //一餐厅
                else if (res.data[i].meterNumber == "20") {
                  this.linkDataArray[5].text =
                    res.data[i].waterAmount.toString();
                }
                //二餐厅
                else if (res.data[i].meterNumber == "21") {
                  this.linkDataArray[7].text =
                    res.data[i].waterAmount.toString();
                }
                //行政办公楼
                else if (res.data[i].meterNumber == "23") {
                  this.linkDataArray[12].text =
                    res.data[i].waterAmount.toString();
                }
                //新宿舍楼
                else if (res.data[i].meterNumber == "24") {
                  this.linkDataArray[14].text =
                    res.data[i].waterAmount.toString();
                }
                //集控楼
                else if (res.data[i].meterNumber == "18") {
                  this.linkDataArray[16].text =
                    res.data[i].waterAmount.toString();
                }
                //矿井水
                else if (res.data[i].meterNumber == "1") {
                  this.linkDataArray[17].text =
                    res.data[i].waterAmount.toString();
                }
                //深度处理进水
                else if (res.data[i].meterNumber == "8") {
                  this.linkDataArray[18].text =
                    res.data[i].waterAmount.toString();
                }
                //深度处理出水
                else if (res.data[i].meterNumber == "9") {
                  this.linkDataArray[19].text =
                    res.data[i].waterAmount.toString();
                }
                //余热补水
                else if (res.data[i].meterNumber == "17") {
                  this.linkDataArray[21].text =
                    res.data[i].waterAmount.toString();
                }
                 //浴室用水
                else if (res.data[i].meterNumber == "25") {
                  this.linkDataArray[23].text =
                    res.data[i].waterAmount.toString();
                }
                //锅炉房
                else if (res.data[i].meterNumber == "15") {
                  var b1 = res.data[i].waterAmount;
                  this.linkDataArray[29].text =
                    res.data[i].waterAmount.toString();
                } else if (res.data[i].meterNumber == "16") {
                  var b2 = res.data[i].waterAmount;
                  this.linkDataArray[29].text =
                    res.data[i].waterAmount.toString();
                }
                //装车站
                else if (res.data[i].meterNumber == "19") {
                  this.linkDataArray[27].text =
                    res.data[i].waterAmount.toString();
                }
                //井下生产
                else if (res.data[i].meterNumber == "5") {
                  this.linkDataArray[32].text =
                    res.data[i].waterAmount.toString();
                }
                //灌浆站
                else if (res.data[i].meterNumber == "10") {
                  this.linkDataArray[34].text =
                    res.data[i].waterAmount.toString();
                }
                //选煤厂用水
                else if (res.data[i].meterNumber == "11") {
                  this.linkDataArray[35].text =
                    res.data[i].waterAmount.toString();
                }
                //副井口
                else if (res.data[i].meterNumber == "7") {
                  this.linkDataArray[38].text =
                    res.data[i].waterAmount.toString();
                }
                //主井口
                else if (res.data[i].meterNumber == "6") {
                  this.linkDataArray[40].text =
                    res.data[i].waterAmount.toString();
                }
                //绿化洒水
                else if (res.data[i].meterNumber == "26") {
                  var c1 = res.data[i].waterAmount;
                  this.linkDataArray[42].text =
                    res.data[i].waterAmount.toString();
                } else if (res.data[i].meterNumber == "27") {
                  var c2 = res.data[i].waterAmount;
                  this.linkDataArray[42].text =
                    res.data[i].waterAmount.toString();
                }
                //汽车冲洗
                else if (res.data[i].meterNumber == "13") {
                  this.linkDataArray[44].text =
                    res.data[i].waterAmount.toString();
                }
                //矸石综合治理
                else if (res.data[i].meterNumber == "14") {
                  this.linkDataArray[46].text =
                    res.data[i].waterAmount.toString();
                }
                //生活污水进口
                else if (res.data[i].meterNumber == "28") {
                  var d1 = res.data[i].waterAmount;
                  this.linkDataArray[58].text =
                    res.data[i].waterAmount.toString();
                } else if (res.data[i].meterNumber == "29") {
                  var d2 = res.data[i].waterAmount;
                  this.linkDataArray[58].text =
                    res.data[i].waterAmount.toString();
                }
                //生活污水出口
                else if (res.data[i].meterNumber == "30") {
                  this.linkDataArray[59].text =
                    res.data[i].waterAmount.toString();
                }
                //生活污水到选煤厂
                else if (res.data[i].meterNumber == "12") {
                  this.linkDataArray[60].text =
                    res.data[i].waterAmount.toString();
                }

                //地下水
                if (a1 || a2) {
                  this.linkDataArray[0].text = a1 + a2;
                } else {
                  this.linkDataArray[0].text = "0";
                }
                //锅炉房
                if (b1 || b2) {
                  this.linkDataArray[29].text = b1 + b2;
                } else {
                  this.linkDataArray[29].text = "0";
                }
                //绿化洒水
                if (c1 || c2) {
                  this.linkDataArray[42].text = c1 + c2;
                } else {
                  this.linkDataArray[42].text = "0";
                }
                //生活污水进口
                if (d1 || d2) {
                  this.linkDataArray[58].text = d1 + d2;
                } else {
                  this.linkDataArray[58].text = "0";
                }
              }
              this.myDiagram.model = new go.GraphLinksModel(
                this.nodeDataArray,
                this.linkDataArray
              );
            });
        } else {
          this.$message.error("获取数据失败！");
        }
      });
    },
  },
};
</script>
<style scoped  lang="less">
#mygoChart {
  height: 100%;
  width: 100%;
  /* background-image: url('../../assets/images/waterBg.gif'); */
}
#timeChoose {
  padding: 12px 0 12px 12px;
  width: 100%;
  height: 100%;
  position: absolute;
  .rowClass {
    .colClass {
      text-align: center;
      background-color: #ffffff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5spx;
      padding-top: 20px;
    }
  }
}
</style>